import React from 'react';
import { NextArrowStyle, PrevArrowStyle } from './styles/NextPrevArrow.styled';

export function NextArrow(props) {
  const { handleNext, onClick, currentSlide, slideCount, dir } = props;

  return (
    <NextArrowStyle
      isDisabled={+currentSlide === +slideCount - 1}
      onClick={() => {
        handleNext(+currentSlide, +slideCount - 1);
        if (+currentSlide < +slideCount - 1) onClick();
      }}
      dir={dir}
    />
  );
}

export function PrevArrow(props) {
  const { handlePrev, onClick, currentSlide, dir } = props;

  return (
    <PrevArrowStyle
      isDisabled={+currentSlide === 0}
      onClick={() => {
        handlePrev(+currentSlide);
        if (+currentSlide > 0) onClick();
      }}
      dir={dir}
    />
  );
}
